import BattlesService from 'services/battles/BattlesService';
import { useMutation } from 'react-query';
import AvailableBattleGroup from 'models/battles/AvailableBattleGroup';

export type UseStartNewDuelProps = {
	selectedGroup: AvailableBattleGroup | null;
	'services.battlesService': BattlesService;
};

export type UseStartNewDuelReturn = ReturnType<typeof useStartNewDuel>;

export const useStartNewDuel = (props: UseStartNewDuelProps) => {
	const battlesService = props['services.battlesService'];

	return useMutation(() => {
		if (props.selectedGroup) {
			return battlesService.startNewDuel(props.selectedGroup.id);
		}

		return Promise.reject(new Error('No AvailableBattleGroup selected.'));
	});
};

export default useStartNewDuel;
